import { useEffect, useState } from "react";
import axios from "axios";

// One-tap attendance confirmation — the destination of the "Yes, I am coming"
// button in the pre-event reminder email (mirror of ScheduleCancel).
export default function ScheduleConfirm() {
  const token = new URLSearchParams(window.location.search).get("token");
  const base = import.meta.env.VITE_APP_API_BASE_URL;
  const [info, setInfo] = useState(null);
  const [state, setState] = useState("loading"); // loading | ready | done | error | notfound
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!token) {
      setState("error");
      setMessage("Missing confirmation link.");
      return;
    }
    axios
      .get(`${base}/confirm`, { params: { token } })
      .then((r) => {
        setInfo(r.data.data);
        setState(r.data.data?.attendanceConfirmedAt ? "done" : "ready");
        if (r.data.data?.attendanceConfirmedAt) {
          setMessage("Your attendance is already confirmed. Hari Om 🙏");
        }
      })
      .catch((e) => {
        setState(e.response?.status === 404 ? "notfound" : "error");
        setMessage("We could not find this booking.");
      });
  }, [token, base]);

  const confirm = async () => {
    try {
      setState("loading");
      const r = await axios.post(`${base}/confirm`, { token });
      setMessage(r.data.message || "Attendance confirmed. Hari Om 🙏");
      setState("done");
    } catch (e) {
      setMessage(
        e.response?.data?.message || "Something went wrong. Please try again."
      );
      setState("error");
    }
  };

  return (
    <div className="max-w-lg mx-auto px-4 py-16 text-center font-serif text-[#241511]">
      <h1 className="text-2xl text-[#9d1f1c] mb-4">Confirm your attendance</h1>
      {state === "loading" && <p>Please wait…</p>}
      {state === "notfound" && <p>{message}</p>}
      {state === "error" && <p className="text-red-700">{message}</p>}
      {state === "ready" && info && (
        <div className="space-y-4">
          <p>
            Hari Om {info.name}, you're booked
            {info.eventLocation ? ` at ${info.eventLocation}` : ""}
            {info.partySize
              ? ` for ${info.partySize} ${info.partySize > 1 ? "people" : "person"}`
              : ""}
            .
          </p>
          <p>Please confirm you are coming, so every seat serves a devotee.</p>
          <button
            onClick={confirm}
            className="bg-[#1c6b30] hover:bg-[#155224] text-white px-6 py-2 rounded-lg"
          >
            Yes, I am coming
          </button>
        </div>
      )}
      {state === "done" && (
        <p className="text-green-800">
          {message || "Attendance confirmed — we look forward to welcoming you. Hari Om 🙏"}
        </p>
      )}
    </div>
  );
}
